/*
 * Created Date: 28-04-2022, 2:37:24 pm
 * Author: Peter
 * Email: phantrung696@gmail.com
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2022 EDUFIT GROUP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import { DateRangePicker, LocalizationProvider } from '@mui/lab'
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import { Icon, InputAdornment, TextField } from '@mui/material'
import enLocale from 'date-fns/locale/en-US'
import PropTypes from 'prop-types'
import React from 'react'
import { useController } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

const CoreDateRangerPicker = props => {
	const { name, control, className, sizeInput, minDate, maxDate, ...resProps } = props
	const { t } = useTranslation('common')
	const {
		field: { onChange, value }
	} = useController({
		name,
		control,
		defaultValue: [null, null]
	})

	return (
		<div className={className}>
			<LocalizationProvider dateAdapter={AdapterDateFns} locale={enLocale}>
				<DateRangePicker
					className={className}
					startText={t('from_date')}
					endText={t('to_date')}
					value={value}
					onChange={newValue => {
						onChange(newValue)
					}}
					inputFormat="dd/MM/yyyy"
					// defaultCalendarMonth={subMonths(new Date(), 1)}
					// maxDate={endOfMonth(subMonths(new Date(), 1))}
					minDate={minDate}
					maxDate={maxDate}
					renderInput={(startProps, endProps) => (
						<>
							<TextField
								{...startProps}
								fullWidth
								className="mr-12"
								size={sizeInput ?? 'medium'}
								InputProps={{
									endAdornment: (
										<InputAdornment position="end">
											<Icon>date_range</Icon>
										</InputAdornment>
									)
								}}
							/>

							<TextField
								{...endProps}
								fullWidth
								size={sizeInput ?? 'medium'}
								InputProps={{
									endAdornment: (
										<InputAdornment position="end">
											<Icon>date_range</Icon>
										</InputAdornment>
									)
								}}
							/>
						</>
					)}
					clearable
					{...resProps}
				/>
			</LocalizationProvider>
		</div>
	)
}

// CoreDateRangerPicker.defaultProps = {}

CoreDateRangerPicker.propTypes = {
	name: PropTypes.string,
	control: PropTypes.object.isRequired,
	className: PropTypes.string
}

export default React.memo(CoreDateRangerPicker)
